import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';
var Trigger = function Trigger(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    mode = props.mode,
    disabled = props.disabled,
    showFoldIcons = props.showFoldIcons,
    foldIcons = props.foldIcons,
    hideFirstPanel = props.hideFirstPanel,
    hideSecondPanel = props.hideSecondPanel,
    handleMousedown = props.handleMousedown;
  var triggerPrefixCls = "".concat(prefixCls, "-trigger");
  var isVertical = mode === 'vertical';
  var getCustomFoldIcons = function getCustomFoldIcons(index) {
    return foldIcons && foldIcons[index];
  };
  var triggerCls = classNames(triggerPrefixCls, isVertical ? "".concat(triggerPrefixCls, "-vertical") : "".concat(triggerPrefixCls, "-horizontal"), _defineProperty({}, "is-disabled", disabled));
  var getArrowCls = function getArrowCls(cls) {
    return classNames("".concat(triggerPrefixCls, "-arrow"), isVertical ? "is-vertical" : "is-horizontal", cls);
  };
  var firstCustomIcons = getCustomFoldIcons(0);
  var secondCustomIcons = getCustomFoldIcons(1);
  var renderFoldIcons = function renderFoldIcons() {
    if (!showFoldIcons) {
      return null;
    }
    var firstIconPos = isVertical ? 'left' : 'top';
    var secondIconPos = isVertical ? 'right' : 'bottom';
    var firstIconType = isVertical ? 'arrow-left-solid' : 'arrow-up-solid';
    var secondIconType = isVertical ? 'arrow-right-solid' : 'arrow-down-solid';
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: getArrowCls(firstIconPos),
      onClick: function onClick(e) {
        return hideFirstPanel(e, firstIconPos);
      }
    }, firstCustomIcons || /*#__PURE__*/React.createElement(Icon, {
      type: firstIconType
    })), /*#__PURE__*/React.createElement("span", {
      className: getArrowCls(secondIconPos),
      onClick: function onClick(e) {
        return hideSecondPanel(e, secondIconPos);
      }
    }, secondCustomIcons || /*#__PURE__*/React.createElement(Icon, {
      type: secondIconType
    })));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: triggerCls,
    style: style,
    onMouseDown: handleMousedown
  }), renderFoldIcons());
};
export default /*#__PURE__*/React.memo(Trigger);